import { useState, useCallback } from "react";

/**
 * Hook for managing container launch state and actions
 * Handles the launch flow with loading states and result visibility
 */
export const useContainerLaunch = () => {
  const [showResults, setShowResults] = useState(false);
  const [hasLaunched, setHasLaunched] = useState(false);
  const [isLaunching, setIsLaunching] = useState(false);

  const handleShowResults = useCallback((show: boolean) => {
    setShowResults(show);
  }, []);

  const handleLaunch = useCallback(
    async (refetchFn?: () => Promise<any>) => {
      if (!showResults) {
        setIsLaunching(true);
        setTimeout(() => {
          setShowResults(true);
          setHasLaunched(true);
          setIsLaunching(false);
        }, 300);
      }
      if (refetchFn) {
        await refetchFn();
      }
    },
    [showResults],
  );

  const handlePanelResize = useCallback((sizes: number[]) => {
    const rightPanelSize = sizes[1];
    if (rightPanelSize < 5) {
      setShowResults(false);
    }
  }, []);

  return {
    showResults,
    hasLaunched,
    isLaunching,
    setShowResults,
    setHasLaunched,
    handleShowResults,
    handleLaunch,
    handlePanelResize,
  };
};
